import ComponentLoader from 'components/ComponentLoader'
import React from 'react'

function importWorkoutComponent () {
  return import(/* webpackChunkName: "modules/workout/redux/containers/Workout" */ 'pages/Workout')
}

export default function getWorkoutComponentRouteUtil (props) {
  if (WORKOUT || (SERVER && global.WORKOUT)) {
    const Workout = require('pages/Workout').default
    return <Workout {...props} />
  } else {
    return (
      <ComponentLoader
        loadComponent={importWorkoutComponent}
        {...props}
      />
    )
  }
}
